import { render, staticRenderFns } from "./BucketDropzone.vue?vue&type=template&id=2c502bd6"
import script from "./BucketDropzone.vue?vue&type=script&lang=js"
export * from "./BucketDropzone.vue?vue&type=script&lang=js"
import style0 from "./BucketDropzone.vue?vue&type=style&index=0&id=2c502bd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports